<template>
    <div class="layer_pop_wrap">
        <div class='layer_pop_dim' :style="active? 'display: block;' : 'display: none'">
            <div class="layer_pop sm" :class="active? 'active' : ''" data-role-popup="modal_01" tabindex="0">
                <div class="pop_head">
                    <h2>비밀번호 변경</h2>
                    <button type="button" class="pop_close" @click="close">닫기</button>
                </div>
                <div class="pop_cont">
                    <div class="form_cont">
                        <ul class="column col_1 first">
                            <li>
                                <div class="label_txt">
                                    <span>현재 비밀번호<em>*</em></span>
                                </div>
                                <div class="column_input">
                                    <input type="password" v-model="password" @keyup.enter.prevent="editPassword"
                                           :class="{'validation_error':passwordValid.error}"
                                           placeholder="현재 비밀번호를 입력하세요."/>
                                    <p v-show="passwordValid.error" v-text="passwordValid.errorMsg"
                                       class="validation_text"></p>
                                </div>
                            </li>
                          <li>
                            <div class="label_txt">
                              <span>새 비밀번호<em>*</em></span>
                            </div>
                            <div class="column_input">
                              <input type="password" v-model="newPassword" @input @keyup.enter.prevent="editPassword" @input="passwordStrengthCheck" @keydown="passwordStrengthCheck"
                                     :class="{'validation_error':newPasswordValid.error}"
                                     placeholder="영문 대소문자, 숫자, 특수문자를 포함. 최소 8자 이상"/>
                              <p v-show="newPasswordValid.error" v-text="newPasswordValid.errorMsg"
                                 class="validation_text"></p>
                            </div>
                            <div class="pw_danger_area">
                              <div class="pw_danger_bar_wrap">
                                <!--
                                    안전도에 따라 pw_danger_bar에 active 클래스 추가
                                -->
                                <div class="pw_danger_bar weak"
                                     :class="passwordStrength == 0 || passwordStrength == 1? `active` : ``"
                                ><span></span></div>
                                <div class="pw_danger_bar medium"
                                     :class="passwordStrength == 2? `active` : ``"
                                ><span></span></div>
                                <div class="pw_danger_bar strong"
                                     :class="passwordStrength == 3? `active` : ``"
                                ><span></span></div>
                              </div>
                              <div class="pw_danger_txt">
                                <p v-if="passwordStrength == 0 || passwordStrength == 1" class="danger_weak">Weak</p>
                                <p v-else-if="passwordStrength == 2" class="danger_medium">Medium</p>
                                <p v-else class="danger_strong">Strong</p>
                              </div>
                            </div>
                          </li>
                            <li>
                                <div class="label_txt">
                                    <span>새 비밀번호 확인<em>*</em></span>
                                </div>
                                <div class="column_input">
                                    <input type="password" v-model="newPasswordConfirm"
                                           @keyup.enter.prevent="editPassword"
                                           :class="{'validation_error':newPasswordConfirmValid.error}"
                                           placeholder="영문 대소문자, 숫자, 특수문자를 포함. 최소 8자 이상"/>
                                    <p v-show="newPasswordConfirmValid.error" v-text="newPasswordConfirmValid.errorMsg"
                                       class="validation_text"></p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="pop_foot">
                    <button type="button" class="sm_btn" @click="close">취소</button>
                    <button type="button" class="sm_btn color_1" @click="editPassword">변경하기</button>
                </div>
            </div>
        </div>
    </div>
</template>

<!-- publicActive -->

<script>
    export default {
        props: {
            active: {
                type: Boolean, default: false
            }
        },
        data() {
            return {
                password: "",
                passwordValid: {
                    error: false,
                    errorMsg: "",
                },
                newPassword: "",
                newPasswordValid: {
                    error: false,
                    errorMsg: "",
                },
                newPasswordConfirm: "",
                newPasswordConfirmValid: {
                    error: false,
                    errorMsg: "",
                },
                errorMsgList: ["입력되지 않았습니다.", "새 비밀번호를 동일하게 입력해 주세요.","형식이 올바르지 않습니다."],
              passwordStrength : 0,
              regexPassword:  /^(?=.*[a-zA-Z])((?=.*\d)|(?=.*\W))(?=.*?[0-9])(?=.*?[#?!@$ %^&*-]).{8,50}$/,
            }
        },
        methods: {
          close() {
            this.passwordStrength = 0;
            this.$emit("close");
          },
          async editPassword() {

            if (this.password.trim().length <= 0) {
              this.passwordValid.error = true;
              this.passwordValid.errorMsg = this.errorMsgList[0];
            } else {
              this.passwordValid.error = false;
            }
            if (this.newPassword.trim().length <= 0) {
              this.newPasswordValid.error = true;
              this.newPasswordValid.errorMsg = this.errorMsgList[0];
            }else if(!this.regexPassword.test(this.newPassword)){
              this.newPasswordValid.error = true;
              this.newPasswordValid.errorMsg = this.errorMsgList[2];
            } else {
              this.newPasswordValid.error = false;
            }
            if (this.newPasswordConfirm.trim().length <= 0) {
              this.newPasswordConfirmValid.error = true;
              this.newPasswordConfirmValid.errorMsg = this.errorMsgList[0];
            } else if (this.newPassword !== this.newPasswordConfirm) {
              this.newPasswordConfirmValid.error = true;
              this.newPasswordConfirmValid.errorMsg = this.errorMsgList[1];
            } else {
              this.newPasswordConfirmValid.error = false;
            }

            if (
                !(this.passwordValid.error
                    || this.newPasswordValid.error
                    || this.newPasswordConfirmValid.error)
            ) {
              const data = await this.$wApi.user.mypage.edit.password(
                  {
                    password: this.password,
                    newPassword: this.newPassword,
                    newPasswordConfirm: this.newPasswordConfirm,
                  },
                  null,
                  {useError: true}
              );
              if (data.error) {
                this.close();
                window.alert(data.message);
                this.password = "";
                this.newPassword = "";
                this.newPasswordConfirm = "";
              } else {
                this.password = "";
                this.newPassword = "";
                this.newPasswordConfirm = "";
                this.close();
                window.wToast("비밀번호가 저장되었습니다.", {variant: "platform"});
              }
            }
          },
          passwordStrengthCheck() {
            if (!this.newPassword) {
              return;
            }

            let strength = 0
            const regexes = [
              /[a-z]+/,
              /[0-9]+/,
              /[$@#&!]+/,
            ]

            regexes.forEach((regex, index) => {
              let password = this.newPassword;
              strength += password.match(regex) ? 1 : 0
            })

            this.passwordStrength = strength
          },

          regexPassed(deleteTarget) {
            let flag = true;
            let regexTarget = {...this.regexCondition};
            if (deleteTarget != null && deleteTarget.length > 0) {
              for (var i = 0; i < deleteTarget.length; i++) {
                delete regexTarget[deleteTarget[i]];
              }
            }
            for (let key in regexTarget) {
              const regex = regexTarget[key];
              if (!regex.test(this.input[key].value)) {
                if (key === "loginId") {
                  this.input[key].validMessage = "영문자로 시작하는 영문자 또는 숫자 6~20자이어야합니다.";
                } else if (key === 'password') {
                  this.input[key].validMessage = "영문 대･소문자, 숫자, 특수문자를 포함, 최소 8자 이상이어야 합니다.";
                } else {
                  this.input[key].validMessage = "형식에 맞지않습니다.";
                }
                flag = false;
                /*alert(`key = ${key} flag = ${flag}`)*/
              } else {
                this.input[key].validMessage = null;
              }
            }
            return flag;
          },
        }
    }
</script>